export default __webpack_public_path__ + "static/media/afr_3.9543f711.png";